module.exports = "/_next/static/images/avatar.b4f8e7b84ac3e99a9bc33cd968afcffd.jpg";